module.exports = __webpack_public_path__ + "static/media/CSE Beyond.2058e30e.jpg";